import { sendForgotPasswordLink } from '../../../../actions/shop/forgotPassword/sendForgotPasswordLink';

async function submit(values, dispatch) {
  dispatch(sendForgotPasswordLink(values.email));
}

export default submit;
